import { createStore, applyMiddleware, compose } from "redux";
import { StoreState } from "./storeState";
import reducer from "../reducers";
import thunk from "redux-thunk";

export default function configureStore(initialStore: StoreState) {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [];
  // middlewares for all environments env
  middlewares.push(thunk);
  
  // middlewares for dev only, redux-logger MUST be LAST in the middlewares array
  if (process.env.NODE_ENV === `development`) {
    const { logger } = require(`redux-logger`);  
    middlewares.push(logger);
  }

  const store = createStore(reducer, initialStore, composeEnhancers(applyMiddleware(...middlewares)));

  const m: any = module;
  if (process.env.NODE_ENV !== "production") {
    if (m.hot) {
      m.hot.accept("../reducers", () => {
        store.replaceReducer(reducer);
      });
    }
  }

  return store;
}
